import Choices from "choices.js";

let element = document.querySelector('#educator_selector');

if (element) {

    var multipleFetch = new Choices('#educator_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: 'Eğitmen seçin',
        removeItemButton: true,
        loadingText: 'Yükleniyor...',
        noResultsText: 'Arama sonucu bulunamadı',
        noChoicesText: 'Seçecek değer bulunamadı',
        itemSelectText: 'Seçmek için tıklayın',
      }).setChoices(function() {
        return fetch(
          '/admin/api/educators',
        )
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            return data.map(function(educator) {
              return { value: educator.id, label: educator.title };
            });
          });
      });

}


let element2 = document.querySelector('#user_selector');

if (element2) {
    const users = element2.getAttribute('data-users');
    var multipleFetch = new Choices('#user_selector', {
        allowHTML: false,
        placeholder: true,
        placeholderValue: 'Sorumlu seçin',
        removeItemButton: true,
        loadingText: 'Yükleniyor...',
        noResultsText: 'Arama sonucu bulunamadı',
        noChoicesText: 'Seçecek değer bulunamadı',
        itemSelectText: 'Seçmek için tıklayın',
      }).setChoices(function() {
        return users.map(user => {
            return {
                value: user.id,
                label: user.name,
            }
        });
      });

}


